var _rect, _g, _g2, _defs, _path, _g3, _g4, _defs2, _linearGradient, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.dev/svgjs",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.7,0,0,0.7,149.57575757575756,282.1265587044535)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 396 247",
    "data-background-color": "#ffffff",
    preserveAspectRatio: "xMidYMid meet",
    height: 623,
    width: 1000,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tight-bounds",
    transform: "matrix(1,0,0,1,0.2400000000000091,-0.09999999999999432)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 247.2",
    height: 247.2,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 247.2",
    height: 247.2,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,75.54432,104.53539380761049)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 244.43135999999998 38.12921238477901",
    height: 38.12921238477901,
    width: 244.43135999999998,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 244.43135999999998 38.12921238477901",
    height: 38.12921238477901,
    width: 244.43135999999998,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 244.43135999999998 38.12921238477901",
    height: 38.12921238477901,
    width: 244.43135999999998,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 244.43135999999998 38.12921238477901",
    height: 38.12921238477901,
    width: 244.43135999999998,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "textblocktransform"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 244.43135999999998 38.12921238477901",
    height: 38.12921238477901,
    width: 244.43135999999998,
    id: "textblock",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 244.43135999999998 38.12921238477901",
    height: 38.12921238477901,
    width: 244.43135999999998,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 244.43135999999998,
    viewBox: "3.25 -33 211.5399932861328 33",
    height: 38.12921238477901,
    "data-palette-color": "url(#1b822cf7-54e2-4fa2-ab22-d692b07080c6)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props))))))))), _g || (_g = /*#__PURE__*/React.createElement("g", null)))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.811 95.534A122.216 122.216 0 0 1 316.709 95.534L313.271 95.534A118.777 118.777 0 0 0 82.249 95.534L78.811 95.534M78.811 151.666A122.216 122.216 0 0 0 316.709 151.666L313.271 151.666A118.777 118.777 0 0 1 82.249 151.666L78.811 151.666",
    fill: "#aaaaaa",
    stroke: "transparent",
    "data-fill-palette-color": "tertiary"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("mask", {
    id: "cce77493-33d9-4ea3-9cf3-f49a521b9681"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1291"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 247.2",
    height: 247.2,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 247.2",
    height: 247.2,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,75.54432,104.53539380761049)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 244.43135999999998 38.12921238477901",
    height: 38.12921238477901,
    width: 244.43135999999998,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 244.43135999999998 38.12921238477901",
    height: 38.12921238477901,
    width: 244.43135999999998,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 244.43135999999998 38.12921238477901",
    height: 38.12921238477901,
    width: 244.43135999999998,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 244.43135999999998 38.12921238477901",
    height: 38.12921238477901,
    width: 244.43135999999998,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1290"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 244.43135999999998 38.12921238477901",
    height: 38.12921238477901,
    width: 244.43135999999998,
    id: "SvgjsSvg1289",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 244.43135999999998 38.12921238477901",
    height: 38.12921238477901,
    width: 244.43135999999998,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 244.43135999999998,
    viewBox: "3.25 -33 211.5399932861328 33",
    height: 38.12921238477901,
    "data-palette-color": "url(#1b822cf7-54e2-4fa2-ab22-d692b07080c6)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 0L3.25 0 3.25-1 7.2-2.5 7.2-30.5 3.25-32 3.25-33 15.2-33 15.2-32 11.1-30.5 11.1-18.2 28.85-18.2 28.85-30.5 24.75-32 24.75-33 36.7-33 36.7-32 32.75-30.5 32.75-2.5 36.7-1 36.7 0 24.75 0 24.75-1 28.85-2.5 28.85-15.85 11.1-15.85 11.1-2.5 15.2-1 15.2 0ZM50.45 0L41.6 0 41.6-1 44.05-1.95 55.15-28.25 56.8-28.25 67.8-2.1 70.6-1 70.6 0 60.35 0 60.35-1 63.95-2.05 60.6-10.1 50-10.1 46.7-2 50.45-1 50.45 0ZM55.25-23.05L50.85-12.2 59.75-12.2 55.25-23.05ZM85.9 0L75.5 0 75.5-1 79.05-2.25 79.05-25.75 75.5-27 75.5-28 85.59-28Q90.25-28 92.9-26.1 95.55-24.2 95.55-21L95.55-21Q95.55-18.45 93.97-16.7 92.4-14.95 89.7-14L89.7-14 97.65-2.1 100.75-1 100.75 0 94.5 0 86.15-13 82.59-13 82.59-2.3 85.9-1 85.9 0ZM85.34-25.85L85.34-25.85 82.59-25.85 82.59-15.15 85.59-15.15Q88.4-15.15 90.05-16.6 91.7-18.05 91.7-20.45L91.7-20.45Q91.7-23.05 90.05-24.45 88.4-25.85 85.34-25.85ZM114.29 0L104.04 0 104.04-1 107.34-2.25 107.34-25.75 104.04-27 104.04-28 114.29-28 114.29-27 110.94-25.75 110.94-2.25 114.29-1 114.29 0ZM139.09 0L126.64 0 126.64-1 131.04-2.25 131.04-25.85 123.14-25.85 120.94-19.9 120.04-19.9 120.04-28 145.74-28 145.74-19.9 144.84-19.9 142.59-25.85 134.64-25.85 134.64-2.25 139.09-1 139.09 0ZM162.04 0L151.24 0 151.24-1 154.74-2.25 154.74-25.75 151.24-27 151.24-28 162.04-28 162.04-27 158.34-25.75 158.34-15.55 173.89-15.55 173.89-25.75 170.14-27 170.14-28 180.89-28 180.89-27 177.44-25.75 177.44-2.25 180.89-1 180.89 0 170.14 0 170.14-1 173.89-2.25 173.89-13.4 158.34-13.4 158.34-2.25 162.04-1 162.04 0ZM194.64 0L185.79 0 185.79-1 188.24-1.95 199.34-28.25 200.99-28.25 211.99-2.1 214.79-1 214.79 0 204.54 0 204.54-1 208.14-2.05 204.79-10.1 194.19-10.1 190.89-2 194.64-1 194.64 0ZM199.44-23.05L195.04-12.2 203.94-12.2 199.44-23.05Z",
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "white",
    className: "wordmark-text-0",
    id: "SvgjsPath1288"
  })))))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", null)))))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0.5,
    y2: 0.5,
    id: "1b822cf7-54e2-4fa2-ab22-d692b07080c6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f00b51",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#730062",
    offset: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 395.5199890136719,
    height: 247.1999969482422,
    fill: "url(#1b822cf7-54e2-4fa2-ab22-d692b07080c6)",
    mask: "url(#cce77493-33d9-4ea3-9cf3-f49a521b9681)",
    "data-fill-palette-color": "primary"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 395.52,
    height: 247.2,
    fill: "none",
    stroke: "none",
    visibility: "hidden"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColor);
export default __webpack_public_path__ + "static/media/logoColor.c7549fa6d5ed9b496d8e3c703e57c345.svg";
export { ForwardRef as ReactComponent };